import React from "react"
import {Button, Spinner} from "react-bootstrap"
import Modal from "react-bootstrap/Modal"
import "./TradeInLoaderModal.scss"

const TradeInLoaderModal = ({showModal, status, onContinue, tunnelData}) => {
  const isLoading = status === "loading"
  const isTimeout = status === "timeout"
  const isFound = status === "found"

  return (
    <Modal show={showModal} backdrop="static" keyboard={false} centered dialogClassName="tradein-loader-modal">
      <Modal.Body className="text-center p-5">
        {isLoading && (
          <>
            <Spinner style={{width: "4rem", height: "4rem", borderColor: tunnelData?.brandColor, borderRightColor: "transparent"}} animation="border" role="status" className="mb-4"></Spinner>
            <h2>
              Il sistema sta prendendo in considerazione le modifiche,
              <br />
              <span style={{display: "block", textAlign: "center"}}>si prega di attendere</span>
            </h2>
          </>
        )}

        {isTimeout && (
          <>
            <h2 className="mb-4">Purtroppo la funzionalità di permuta non è attualmente disponibile. Ti invitiamo a riprovare più tardi.</h2>
            <Button variant="primary" onClick={() => onContinue(false)} className="mt-3">
              Continue
            </Button>
          </>
        )}

        {isFound && (
          <>
            <h2 className="mb-4">Il tuo trade-in è stato elaborato correttamente. Fai clic sul pulsante qui sotto per continuare.</h2>
            <Button variant="primary" onClick={() => onContinue(true)} className="mt-3">
              Continue
            </Button>
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default TradeInLoaderModal
